(function () {
  document.querySelectorAll('[data-faq-interactive]').forEach(function (root) {
    var searchInput = root.querySelector('[data-faq-search]');
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-faq-pill]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    var countEl = root.querySelector('[data-faq-count]');
    var emptyEl = root.querySelector('[data-faq-empty]');
    var activeCategory = 'all';

    function applyFilters() {
      var query = (searchInput ? searchInput.value.trim().toLowerCase() : '');
      var visible = 0;

      items.forEach(function (item) {
        var category = item.getAttribute('data-category');
        var text = item.getAttribute('data-search');
        var matchesCategory = activeCategory === 'all' || category === activeCategory;
        var matchesQuery = query === '' || text.indexOf(query) !== -1;
        var show = matchesCategory && matchesQuery;
        item.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      if (countEl) countEl.textContent = visible;
      if (emptyEl) emptyEl.classList.toggle('visible', visible === 0);
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
        activeCategory = pill.getAttribute('data-faq-pill');
        applyFilters();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', applyFilters);
    }

    items.forEach(function (item) {
      var q = item.querySelector('[data-faq-toggle]');
      if (!q) return;
      q.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        items.forEach(function (i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });

    applyFilters();
  });
})();
